import React from 'react';
import FrequencyTableComponent from './FrequencyTableComponent';
import MultiResponse from './MultiResponse';
import DataGrid from './DataGrid';
import MultiDataGrid from './MultiDataGrid';
import Grid3DData from './Grid3DData';
import MyChartComponent from './MyChartComponent';


const TabComp = ({
  isCrossTab,
  frequencyData,
  displayMode,
  displaySettings
  
}) => {
  return (
    <div className="data-display-area">
      <div className="data-content">
        {!isCrossTab &&
          frequencyData &&
          (frequencyData.type === "SingleResponse" ||
            frequencyData.type === "Numeric") &&
          displayMode === "table" && (
            <FrequencyTableComponent
              freq_table={frequencyData}
              displaySettings={displaySettings}
            />
          )}
        
        {!isCrossTab &&
          frequencyData &&
          frequencyData.type === "Multiple2DGrid" &&
          displayMode === "table" && (
            <MultiResponse
              varProperties={frequencyData}
              displaySettings={displaySettings}
            />
          )}
        
        {!isCrossTab &&
          frequencyData &&
          (frequencyData.type === "Single2DGrid" ||
            frequencyData.type === "Numeric2DGrid") &&
          displayMode === "table" && (
            <DataGrid
              gridData={frequencyData}
              displaySettings={displaySettings}
            />
          )}
        
        {!isCrossTab &&
          frequencyData &&
          (frequencyData.type === "Multiple3DGrid" ||
            frequencyData.type === "Single3DGrid") &&
          displayMode === "table" && (
            <MultiDataGrid
              gridData={frequencyData}
              displaySettings={displaySettings}
            />
          )}
        
        {!isCrossTab &&
          frequencyData &&
          frequencyData.type === "Numeric3DGrid" &&
          displayMode === "table" && (
            <Grid3DData
              gridData={frequencyData}
              displaySettings={displaySettings}
            />
          )}
        
        {displayMode === "chart" &&
          frequencyData &&
          Object.entries(frequencyData).map(
            ([varName, freq], index) => (
              <div key={index}>
                <h3>{varName}</h3>
                <MyChartComponent frequencyData={freq} />
              </div>
            )
          )}
        
      </div>
    </div>
  );
};

export default TabComp;